const ar = {
  today: "مباريات اليوم",
  live: "مباشر",
  upcoming: "القادمة",
  stats: "إحصائيات",
  noLive: "لا توجد مباريات مباشرة الآن",
  clickForStats: "انقر للإحصائيات الكاملة",
  viewOdds: "عرض الاحتمالات المباشرة →",
  headToHead: "المواجهات المباشرة",
  form: "الشكل الحالي",
  goalStats: "إحصائيات الأهداف",
  leagueTable: "جدول الدوري",
  injuries: "الإصابات والإيقافات",
  outcome: "النتيجة المحتملة",
  homeWin: "فوز المضيف",
  draw: "تعادل",
  awayWin: "فوز الضيف",
  confidence: "الثقة",
  viewing: "شخص يشاهد",
  subscribe: "احصل على تحليلات أسبوعية مجانية",
  subscribeDesc: "كل جمعة — أفضل 5 مباريات مع الإحصائيات.",
  yourEmail: "بريدك الإلكتروني",
  subscribe_btn: "اشترك مجاناً",
  worldCup: "كأس العالم FIFA 2026",
  daysAway: "أيام متبقية",
  viewQualifiers: "عرض التصفيات",
  featuredMatches: "🔥 المباريات الكبيرة",
  favourite: "الفرق المفضلة",
  addFav: "أضف إلى المفضلة",
  removeFav: "إزالة من المفضلة",
  kickoff: "انطلاق",
  stadium: "ملعب",
  season: "معاينة الموسم",
  loading: "جارٍ تحميل المباريات...",
  avgScored: "متوسط ​​الأهداف",
  avgConceded: "متوسط ​​المستقبلة",
};
export default ar;